import type { DosageTable as DosageTableType } from '../../types'

export function DosageTable({ table }: { table: DosageTableType }) {
  const hasApp = table.rows.some((r) => r.application)
  const hasTiming = table.rows.some((r) => r.timing)
  const hasNote = table.rows.some((r) => r.note)

  return (
    <figure className="m-0">
      {table.title && <h4 className="mb-3 font-display text-lg font-semibold text-ink">{table.title}</h4>}
      <div className="overflow-x-auto rounded-lg border border-sand-200">
        <table className="w-full min-w-[34rem] border-collapse text-sm">
          <thead>
            <tr className="bg-sand-100/70 text-left">
              <th scope="col" className="px-4 py-3 font-semibold text-ink-700">Crop</th>
              {hasApp && <th scope="col" className="px-4 py-3 font-semibold text-ink-700">Application</th>}
              {hasTiming && <th scope="col" className="px-4 py-3 font-semibold text-ink-700">When to apply</th>}
              <th scope="col" className="px-4 py-3 font-semibold text-ink-700">Dose</th>
              {hasNote && <th scope="col" className="px-4 py-3 font-semibold text-ink-700">Notes</th>}
            </tr>
          </thead>
          <tbody>
            {table.rows.map((r, i) => (
              <tr key={r.crop + i} className="border-t border-sand-200 odd:bg-white even:bg-canvas/60">
                <th scope="row" className="px-4 py-3 text-left align-top font-medium text-ink">{r.crop}</th>
                {hasApp && <td className="px-4 py-3 align-top text-ink-500">{r.application ?? '—'}</td>}
                {hasTiming && <td className="px-4 py-3 align-top text-ink-500">{r.timing ?? '—'}</td>}
                <td className="px-4 py-3 align-top font-medium tabular-nums text-ink-700">{r.dose}</td>
                {hasNote && <td className="px-4 py-3 align-top text-ink-500">{r.note ?? '—'}</td>}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {table.caption && <figcaption className="mt-2 text-xs text-ink-500">{table.caption}</figcaption>}
    </figure>
  )
}
